module.exports = __webpack_public_path__ + "static/media/assessment-icon.856aa6b1.svg";